export default ({ wordString }) => {
  
  if (!wordString) {
    return null
  }
  
  const corpusLangCode = 33 // TODO - not just italian
  const wordUrl = wordString.split(' ').join('+')

  return <>
    {/* https://ell.meta.stackexchange.com/questions/4698/how-can-i-insert-a-google-ngram-chart-relatively-easily */}
    <iframe
      src={`https://books.google.com/ngrams/interactive_chart?content=${wordUrl}&corpus=${corpusLangCode}&year_start=1800`}
      width="300"
      height="110"
      hspace="0"
      vspace="0"
      style={{border: 0, maxWidth: '100%'}}
    />

    <p style={{fontSize: 'var(--s)'}}>
      More about
      {' '}
      <a
        href={`https://books.google.com/ngrams/info`}
        target="_blank"
      >
        Google Ngram
      </a>
    </p>

  </>
}
